module.exports = __webpack_public_path__ + "img/强大的全渠道数字化信息平台.1ebb194f.png";